import { canonicalMessage, type LogType } from './canonicalMessage'
import { signMessage } from './crypto'
import { getDevice, nextMonotonicCounter, enqueueOutboxEntry } from './db'

export interface RecordCheckinOptions {
  auftragId?: string
  taetigkeitGeplant?: string
  taetigkeitIst?: string
  zusatzgeraet?: string
}

/** Erfasst einen Stempel: signiert + schreibt SYNCHRON in die Outbox. Die Bestaetigung auf
 * dem Bildschirm haengt an dieser Funktion zurueckzukehren, nicht an einer Netzwerkantwort
 * (Architektur §2 -- "es gibt keinen Pfad, auf dem eine Netzwerkantwort fuer die Quittung
 * noetig ist"). Das eigentliche Uebertragen passiert asynchron danach (lib/sync.ts).
 *
 * `options` (Rapport-Digitalisierung, TQ #18899/#18900) IST Teil der Signatur
 * (canonicalMessage) -- Sicherheitsreview-Fund vor dem Merge: ohne das koennte jemand
 * zwischen PWA und Server auftrag_id/Taetigkeiten aendern, ohne die Geraete-Signatur zu
 * brechen. ANFAHRT/ABFAHRT sind normale LogType-Werte wie IN/OUT. */
export async function recordCheckin(
  employeeIdentifier: string,
  logType: LogType,
  options: RecordCheckinOptions = {},
): Promise<void> {
  const device = await getDevice()
  if (!device) throw new Error('Geraet ist nicht enrollt')

  const eventId = crypto.randomUUID()
  const clientTime = new Date()
  const monotonicCounter = await nextMonotonicCounter()

  const message = canonicalMessage({
    eventId,
    deviceId: device.deviceId,
    employeeIdentifier,
    logType,
    clientTime,
    monotonicCounter,
    auftragId: options.auftragId,
    taetigkeitGeplant: options.taetigkeitGeplant,
    taetigkeitIst: options.taetigkeitIst,
    zusatzgeraet: options.zusatzgeraet,
  })
  const signature = await signMessage(device.privateKey, message)

  await enqueueOutboxEntry({
    eventId,
    deviceId: device.deviceId,
    tenantSlug: device.tenantSlug,
    employeeIdentifier,
    logType,
    clientTimeIso: clientTime.toISOString(),
    monotonicCounter,
    signature,
    createdAt: new Date().toISOString(),
    auftragId: options.auftragId,
    taetigkeitGeplant: options.taetigkeitGeplant,
    taetigkeitIst: options.taetigkeitIst,
    zusatzgeraet: options.zusatzgeraet,
  })
}
